<template lang="pug">
  v-touch.avatar(@tap="viewUser()" :class="{ 'highlight': highlight }" :style="{ height: `${size}px`, width: `${size}px` }")
    .img(v-if="popover" :style="{ width: `${size}px`, backgroundImage: `url(${cdnURL}/members/photo/medium/${user.photo ? user.photo : 'default.jpg'})` }")
    el-popover(v-else placement="bottom-start" width="200" :trigger="trigger")
      h3
        strong {{ parseInfo(user.fullname) || "-" }}
      span(v-if="user.info") {{ parseInfo(user.info) }}
      .img(slot="reference" :style="{ width: `${size}px`, backgroundImage: `url(${cdnURL}/members/photo/medium/${user.photo ? user.photo : 'default.jpg'})` }")
      //- el-tag(size="mini" type="info") {{ user.fullname }}
</template>

<script>
export default {
  name: "Avatar",
  props: {
    user: {
      type: Object,
      required: true
    },
    size: {
      type: Number,
      required: false,
      default: 40
    },
    highlight: {
      type: Boolean,
      required: false,
      default: false
    },
    trigger: {
      type: String,
      required: false,
      default: "hover"
    },
    popover: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  data() {
    return {
      cdnURL: process.env.VUE_APP_CDN_URL
    };
  },
  methods: {
    parseInfo: function(value) {
      return value.replace(/\\/g, "");
    },
    viewUser() {
      this.$router.push({ name: "user", params: { id: this.user._id } });
    }
  }
};
</script>

<style lang="stylus" scoped>
.avatar {
  &:hover {
    cursor: pointer;
  }

  &.highlight {
    opacity: 0.1;
  }

  .img {
    background-image();
    border-radius(50%);
    background-color: $color-lightest-grey;
    border: $color-light-border 1px solid;
    padding-bottom: 100%;
    height: 0 !important;
  }
}
</style>